// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-state-container[data-v-89dff8d0] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n  background: white;\n}\n.icon[data-v-89dff8d0] {\n  width: 50px;\n  height: 44px;\n  margin-bottom: 12px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
